import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n/config.ts";
import ErrorBoundary from "./utils/errors/ErrorBoundary";
import ErrorTemplate from "./utils/errors/ErrorTemplate";
import PiwikPro from '@piwikpro/react-piwik-pro';


PiwikPro.initialize(process.env.REACT_APP_PIWIK_SITE_ID!, process.env.REACT_APP_PIWIK_SITE_URL!);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <>
        <React.StrictMode>
            <div id="page-bg"></div>
            <ErrorBoundary fallback={<ErrorTemplate/>}>
                <App/>
            </ErrorBoundary>
        </React.StrictMode>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
